export const STATUSES = ['PAID', 'FORECAST', 'UNPAID', 'SIGNED', 'OVERDUE'];
